// localStorage-backed MRU list for the page lookup palette (Ctrl/Cmd+Shift+K).
// Scoped per lab (labSlug) so switching labs doesn't surface another lab's
// recently visited pages. Only navigations made through the palette itself
// are recorded — see Page Lookup Palette plan, Phase 3.

export interface IRecentPage {
  id: string
  visitedAt: number
}

const MAX_RECENT_PAGES = 5

function storageKey(labSlug: string): string {
  return `pageLookupRecents:${labSlug}`
}

export function getRecentPageIDs(labSlug: string): string[] {
  try {
    const raw = localStorage.getItem(storageKey(labSlug))
    if (!raw) return []
    const parsed = JSON.parse(raw) as IRecentPage[]
    return parsed.sort((a, b) => b.visitedAt - a.visitedAt).map((entry) => entry.id)
  } catch {
    return []
  }
}

export function addRecentPageID(labSlug: string, id: string, visitedAt: number): void {
  try {
    const raw = localStorage.getItem(storageKey(labSlug))
    const existing: IRecentPage[] = raw ? (JSON.parse(raw) as IRecentPage[]) : []
    const withoutID = existing.filter((entry) => entry.id !== id)
    const updated = [{ id, visitedAt }, ...withoutID].slice(0, MAX_RECENT_PAGES)
    localStorage.setItem(storageKey(labSlug), JSON.stringify(updated))
  } catch {
    // localStorage may be unavailable (private browsing, quota) — the MRU list
    // is a nice-to-have, so fail silently rather than breaking navigation.
  }
}
